import { Component, Input, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { NzModalRef, NzModalService } from 'ng-zorro-antd/modal';
import { doGetInvalidControlsList, doTouchAllFields, WrapperWorkflowActionDto, WrapperWorkflowButtonDto } from '../../workflow-utils';
import { WorkflowFormActionComponent } from '../workflow-form-action/workflow-form-action.component';

@Component({
	selector: 'app-workflow-form-button',
	standalone: false,
	templateUrl: './workflow-form-button.component.html',
	styleUrl: './workflow-form-button.component.scss'
})
export class WorkflowFormButtonComponent implements OnInit {
	@Input() input!: WrapperWorkflowButtonDto;

	constructor(private fb: FormBuilder, private modalRef: NzModalRef, private modalService: NzModalService) {
	}
	ngOnInit(): void {
	}

	addAction() {
		let action = WrapperWorkflowActionDto.add(this.fb, this.input);
		this.input.actions = this.input.actions.sort((i1,i2)=> i1._orderIndex-i2._orderIndex);
		const modal = this.modalService.create({
			nzTitle: 'Add Action',
			nzContent: WorkflowFormActionComponent,
			nzWidth: '75%',
			nzFooter: null
		});
		modal.componentInstance!.input = action;
	}
	removeAction({ index }: { index: number }) {
		WrapperWorkflowActionDto.remove(this.input!, index);
		this.input.actions = this.input.actions.sort((i1,i2)=> i1._orderIndex-i2._orderIndex);
	}
	viewAction(action: WrapperWorkflowActionDto) {
		const modal = this.modalService.create({
			nzTitle: 'Add Action',
			nzContent: WorkflowFormActionComponent,
			nzWidth: '75%',
			nzFooter: null
		});
		modal.componentInstance!.input = action;
		modal.afterClose.subscribe(result => {
			if (result.action == 'delete') {
				WrapperWorkflowActionDto.remove(action.parent, action.parent.actions.indexOf(action));
			}
			this.input.actions = this.input.actions.sort((i1,i2)=> i1._orderIndex-i2._orderIndex);
		});
	}
	onSubmit(): void {
		if (this.input.formGroup.valid) {
			console.log('Form Value:', this.input.formGroup.value);
		} else {
			this.input.formGroup.markAllAsTouched();
		}
	}
	doTouchAllFields(group: FormGroup | FormArray) {
		Object.values(group.controls).forEach(control => {
			if (control instanceof FormControl) {
				control.markAsDirty({ onlySelf: true });
				control.updateValueAndValidity({ onlySelf: true });
			} else if (control instanceof FormGroup || control instanceof FormArray) {
				this.doTouchAllFields(control);
			}
		});
	}
	doClose() {
		this.modalRef.close({ action: 'cancel' });
	}
	doDelete() {
		console.log('Closing modal');
		this.modalRef.close({ action: 'delete', value: this.input });
	}

	compareSelectValues = (o1: any, o2: any): boolean => o1 && o2 ? o1.id === o2.id : o1 === o2;


	// getStepName(action:WrapperWorkflowActionDto): string{
	// 	let sValue = action._actionValue;
	// 	if (!sValue) {
	// 		return '-';
	// 	}
	// 	let value = +sValue;
	// 	return action.parent.parent.parent.steps.filter(item => item.payload.id == value)[0]._label??'No Label';
	// }
	getStateName(action: WrapperWorkflowActionDto): string {
		const statusId = action.payload.movementWorkflowStepStatusId;
		if (!statusId) {
			return "-";
		}
		const step = this.input.parent.parent.steps.filter(item => item.statuses.some(i => i.payload.id == statusId))[0];
		if (!step) {
			return "-";
		}
		const status = this.input.parent.parent.steps.map(item => item.statuses).flat().filter(item => item.payload.id == statusId)[0];
		if (!status) {
			return step!._label!;
		}
		return step._label + ": " + status!._label!;
	}
	getCommunicationName(action: WrapperWorkflowActionDto): string {
		return action.formGroup.get('name')?.value??'-';
	}
	get icon(): string {
		return this.input.formGroup.get('icon')!.value;
	}
}
